import type { ProductColorOption } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { useStore } from 'zustand';
import { usePhotoDraftStore } from '@/entities/edit-area';
import { FACE_LABELS } from '../model/face-labels';

interface PhotoReadinessProps {
  readonly colors: readonly ProductColorOption[];
}

export const PhotoReadiness = ({ colors }: PhotoReadinessProps): ReactElement => {
  const store = usePhotoDraftStore();
  const state = useStore(store);
  const readiness = state.getPhotoReadiness();
  return (
    <div className="space-y-2 text-sm" aria-live="polite">
      <p className="font-medium">
        {readiness.isPhotoStepReady ? '사진 준비 완료' : '사진 준비 미완료'}
      </p>
      {readiness.hasPending ? <p>진행 중인 사진 업로드가 있습니다.</p> : null}
      {readiness.hasErrors ? <p>실패한 업로드를 다시 시도하거나 취소해 주세요.</p> : null}
      {readiness.missing.length > 0 ? (
        <ul className="list-inside list-disc text-muted-foreground">
          {readiness.missing.map(({ colorOptionId, face }) => (
            <li key={`${colorOptionId}:${face}`}>
              {colors.find((color) => color.id === colorOptionId)?.name ?? '색상'} ·{' '}
              {FACE_LABELS[face]} 사진 필요
            </li>
          ))}
        </ul>
      ) : null}
      {state.notice ? <p role="status">{state.notice}</p> : null}
    </div>
  );
};
